import C from '../../../constants';

export const navbar = (state = {}, action) => {
    switch (action.type) {

        case C.NAVBAR_SHOW :
            return Object.assign({}, state, {showNavbar: action.payload});

        case C.FOOTER_SHOW :
            return Object.assign({}, state, {showFooter: action.payload});

        default :
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/containers/navigation/reducers/navbar.js